module.exports = __webpack_public_path__ + "img/d200705b-2.2040f63e.jpg";